module.exports = __webpack_public_path__ + "static/media/01A.bd65a3bf.png";